import axios from 'axios';
import { accessToken, apiUrl } from './strapi.constants';

export const strapiInstance = axios.create({
	baseURL: apiUrl,
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
		Authorization: `Bearer ${accessToken}`,
	},
	withCredentials: false,
});
